import {useState, useEffect, useRef} from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useIsMobile } from "../hooks/useIsMobile"
import '../styles/nav.css'

function NavBar() {
    const isMobile = useIsMobile(768)
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
    const [ratingSubMenuOpen, setRatingSubMenuOpen] = useState(false);
    const [trendSubMenuOpen, setTrendSubMenuOpen] = useState(false)
    const location = useLocation()
    const isHomePage = location.pathname === "/"
    const navRef = useRef()

    useEffect(() => {
        setRatingSubMenuOpen(false)
        setTrendSubMenuOpen(false)
        setIsMobileMenuOpen(false)
    }, [location.pathname])

    useEffect(() => {
        function handleClickOutside(event) {
            if (isMobileMenuOpen && navRef.current && !navRef.current.contains(event.target)) {
                setIsMobileMenuOpen(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [isMobileMenuOpen])

    useEffect(() => {
        if (!isMobile) {
            setIsMobileMenuOpen(false)
        }
    }, [isMobile])

    function closeMenus() {
        setRatingSubMenuOpen(false)
        setTrendSubMenuOpen(false)
    }

    return (
        <nav className={`nav ${isHomePage ? "homeNav" : ""}`} ref={navRef}>
            {isMobile && (
                <button className="hamburgerMenu" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                    <span className={`bar ${isMobileMenuOpen ? "open" : ""}`}></span>
                    <span className={`bar ${isMobileMenuOpen ? "open" : ""}`}></span>
                    <span className={`bar ${isMobileMenuOpen ? "open" : ""}`}></span>
                </button>
            )}
            <div className={`navLinksContainer ${(isMobile && isMobileMenuOpen) ? "active" : ""}`}>
                <NavLink to="/" className={`${isHomePage ? "homeNavLink" : "navLink"}`} onClick={closeMenus}>
                    Home
                </NavLink>

                <div className="navItemWithMenu">
                    <button 
                        type="button"
                        className={`${isHomePage ? "homeNavLink" : "navLink"} ${ratingSubMenuOpen ? "homeNavLinkActive" : ""}`}
                        onClick={() => {
                            setRatingSubMenuOpen(v => !v);
                            setTrendSubMenuOpen(false)
                        }}
                    >
                        Ratings
                    </button>
                
                    <div className={`subMenu ${ratingSubMenuOpen ? "open" : ""}`}>
                        <NavLink to="/ratings/hitters" className="subNavLink" onClick={() => setRatingSubMenuOpen(false)}>
                            Hitters
                        </NavLink>
                        <NavLink to="/ratings/pitchers" className="subNavLink" onClick={() => setRatingSubMenuOpen(false)}>
                            Pitchers
                        </NavLink>
                    </div>
                </div>

                <div className="navItemWithMenu">
                    <button 
                        type="button"
                        className={`${isHomePage ? "homeNavLink" : "navLink"} ${trendSubMenuOpen ? "homeNavLinkActive" : ""}`}
                        onClick={() => {
                            setTrendSubMenuOpen(v => !v);
                            setRatingSubMenuOpen(false)
                        }}
                    >
                        Trends
                    </button>

                    <div className={`subMenu ${trendSubMenuOpen ? "open" : ""}`}>
                        <NavLink to="/trends/hitters" className="subNavLink" onClick={() => setTrendSubMenuOpen(false)}> 
                            Hitters
                        </NavLink>
                        <NavLink to="/trends/pitchers" className="subNavLink" onClick={() => setTrendSubMenuOpen(false)}> 
                            Pitchers
                        </NavLink>
                        <NavLink to="/trends/teams" className="subNavLink" onClick={() => setTrendSubMenuOpen(false)}> 
                            Teams
                        </NavLink>
                    </div>
            </div>
            
            <NavLink to="/matchup-builder" className={`${isHomePage ? "homeNavLink" : "navLink"}`} onClick={closeMenus}>Matchup Builder</NavLink>
            <NavLink to="/pitch-reports" className={`${isHomePage ? "homeNavLink" : "navLink"}`} onClick={closeMenus}>Pitch Usage Reports</NavLink>
            <NavLink to="/picks" className={`${isHomePage ? "homeNavLink" : "navLink"}`} onClick={closeMenus}>
                Picks
            </NavLink>
            <NavLink to="/about" className={`${isHomePage ? "homeNavLink" : "navLink"}`} onClick={closeMenus}>
                About
            </NavLink>
            <NavLink to="/FAQs" className={`${isHomePage ? "homeNavLink" : "navLink"}`} onClick={closeMenus}>
                Help
            </NavLink>
            </div>
        </nav>
    )

}

export default NavBar